/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { OpenAiCorrectTextAnswer } from '../models/open-ai-correct-text-answer';
import { OpenAiCorrectText } from '../models/open-ai-correct-text';
@Injectable({
  providedIn: 'root',
})
class TextkorrekturService extends __BaseService {
  static readonly textkorrekturCreatePath = '/textkorrektur';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param data undefined
   */
  textkorrekturCreateResponse(data: OpenAiCorrectText): __Observable<__StrictHttpResponse<OpenAiCorrectTextAnswer>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/textkorrektur`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OpenAiCorrectTextAnswer>;
      })
    );
  }
  /**
   * @param data undefined
   */
  textkorrekturCreate(data: OpenAiCorrectText): __Observable<OpenAiCorrectTextAnswer> {
    return this.textkorrekturCreateResponse(data).pipe(
      __map(_r => _r.body as OpenAiCorrectTextAnswer)
    );
  }
}

module TextkorrekturService {
}

export { TextkorrekturService }
